import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { authAPI } from '../api';
import { t } from '../i18n';

const VerifyEmail = () => {
  const { uid, token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verify = async () => {
      try {
        await authAPI.verifyEmail(uid, token);
        setStatus('success');
        setMessage(t('emailVerifiedSuccessfully'));
        // Redirect to home after a brief delay
        setTimeout(() => navigate('/'), 2000);
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.error || t('emailVerificationFailed'));
      }
    };
    verify();
  }, [uid, token, navigate]);

  return (
    <div className="container" style={{ maxWidth: 600, margin: '60px auto', textAlign: 'center' }}>
      <div className="card" style={{ padding: 40 }}>
        {status === 'verifying' && <h1>{t('verifying')}</h1>}
        {status === 'success' && (
          <>
            <h1 style={{ color: 'green' }}>✓ {t('verified')}</h1>
            <p style={{ fontSize: 16, marginTop: 20 }}>{message}</p>
            <p style={{ fontSize: 14, color: '#666' }}>{t('redirectingToHome')}</p>
          </>
        )}
        {status === 'error' && (
          <>
            <h1 style={{ color: 'red' }}>{t('verificationFailed')}</h1>
            <p style={{ fontSize: 16, marginTop: 20 }}>{message}</p>
            <button className="btn btn-primary" onClick={() => navigate('/')} style={{ marginTop: 20 }}>
              {t('goToHome')}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
